export enum ROLES {
  MAINTENANCE = 1,
  CAFETERIA_STAFF = 2,
  TEACHER_ASSISTANT = 3,
  SUPPORT_STAFF = 4,
  OFFICE_STAFF = 5,
  OFFICE_MANAGER = 6,
  SPEECH_THERAPIST = 7,
  RSP_TEACHER = 8,
  TEACHER = 9,
  SPED_SUPPORT_STAFF = 10,
  SPED_COORDINATOR = 11,
  VICE_PRINCIPAL = 12,
  PRINCIPAL = 13,
  EXECUTIVE_DIRECTOR = 14,
  COO = 15,
  CBO = 16,
  CAO = 17,
  STUDENT = 18,
  SUPER_ADMIN = 19,
  PARENT = 20,
  IT_ADMINISTRATOR = 21,
  TEACHER_ONLY = 22,
}

export const ROLEVALUES = {
  MAINTENANCE: 1,
  CAFETERIA_STAFF: 2,
  TEACHER_ASSISTANT: 3,
  SUPPORT_STAFF: 4,
  OFFICE_STAFF: 5,
  OFFICE_MANAGER: 6,
  SPEECH_THERAPIST: 7,
  RSP_TEACHER: 8,
  TEACHER: 9,
  SPED_SUPPORT_STAFF: 10,
  SPED_COORDINATOR: 11,
  VICE_PRINCIPAL: 12,
  PRINCIPAL: 13,
  EXECUTIVE_DIRECTOR: 14,
  COO: 15,
  CBO: 16,
  CAO: 17,
  STUDENT: 18,
  SUPER_ADMIN: 19,
  PARENT: 20,
  IT_ADMINISTRATOR: 21,
  TEACHER_ONLY: 22,
};

export const ROLE = {
  TEACHER: 'teacher',
  STUDENT: 'student',
  ADMIN: 'admin',
  TEACHER_ONLY: 'teacher_only',
  PARENT: 'parent',
  SUPER_ADMIN: 'Super Admin',
  STAFF: 'staff',
};

export const EVENT_TYPE = {
  HOLIDAY: 'holiday',
  ACCELERATION: 'acceleration',
  UNASSIGNED: 'unassigned',
  PUPIL: 'pupil',
};

export enum UserRoles {
  Student = 'student',
  Admin = 'admin',
  Teacher = 'teacher',
  TeacherOnly = 'teacher_only',
}
